import _ from '@lodash';
import * as Actions from '../Actions/LookupActions';

const initialState = {
    lookupDialog: []
};

const CidadeReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.OPEN_LOOKUP_DIALOG:
            {
                return {
                    ...state,
                    lookupDialog: [...state.lookupDialog, action.id]
                };
            }
        case Actions.CLOSE_LOOKUP_DIALOG:
            {
                var AArrayTmp = [...state.lookupDialog];
                var AIndex = _.findIndex(state.lookupDialog, action.id);
                AArrayTmp.splice(AIndex);
                return {
                    ...state,
                    lookupDialog: [...AArrayTmp]
                };
            }
        default:
            {
                return state;
            }
    }
};

export default CidadeReducer;
